module.exports = __webpack_public_path__ + "img/OLIGOELEMENTOS.ed3bbdc7.png";